import { render, staticRenderFns } from "./LinkCartao.vue?vue&type=template&id=6ab9f976"
import script from "./LinkCartao.vue?vue&type=script&lang=js"
export * from "./LinkCartao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports